import { Box, styled } from '@mui/material';

export const RowStyle = styled(Box)(() => ({
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
	justifyContent: 'space-between',
}));
